import postRequest from '../../../postRequest';

/**
 * Post request for move styles.
 *
 * @param {number[]} productIds product ids
 * @param {string} styleName style name
 * @param {boolean} overrideStyleNameExistence overrideStyleNameExistence
 *
 */
function postSplitStyles(
  productIds,
  styleName,
  brandId,
  overrideStyleNameExistence,
) {
  const endpoint = '/oc-data-management/v1/styles/split';

  const body = {
    productIds,
    styleName,
    brandId,
    overrideStyleNameExistence,
  };

  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'Styles')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default postSplitStyles;
